/*!
 * GTrack - Analytics
 * Based off of Piwik.org js script
 * @link http://piwik.org
 * @license http://www.gnu.org/licenses/gpl-3.0.html Gpl v3 or later
 * @version $Id: gtrack.js 1320 2017-03-27 10:03:38Z
 */
let GTrack;

if (!window.GTrack) {
  window.GTrack = (function() {
    let z, plugins = {},
      documentAlias = document,
      navigatorAlias = navigator,
      windowAlias = window,
      hasLoaded = false,
      registeredOnLoadHandlers = [],
      pageUrlOverride = null;

    function isDefined(a) {
      return typeof a !== 'undefined'
    }

    function addEventListener(a, b, c, d) {
      a.addEventListener(b, c, d);
      return true;
    }

    function executePluginMethod(a, b) {
      let c = '', i, pluginMethod;
      for (i in plugins) {
        pluginMethod = plugins[i][a];
        if (typeof pluginMethod === 'function') {
          c += pluginMethod(b)
        }
      }
      return c
    }

    function loadHandler() {
      if (!hasLoaded) {
        hasLoaded = true;
        executePluginMethod('load');
        for (let i = 0; i < registeredOnLoadHandlers.length; i++) {
          registeredOnLoadHandlers[i]()
        }
      }
      return true
    }

    function addReadyListener() {
      let handler = function() {
        documentAlias.removeEventListener("DOMContentLoaded", handler, false);
        loadHandler()
      };

      addEventListener(documentAlias, "DOMContentLoaded", handler);
      addEventListener(windowAlias, 'load', loadHandler, false);
    }

    function Tracker(h, j) {
      let l = h || '',
        configTrackerSiteId = j || '',
        configTitle = '',
        configDownloadExtensions = '7z|aac|arc|arj|asf|asx|avi|bin|csv|doc|exe|flv|gif|gz|gzip|hqx|jar|jpe?g|js|mp(2|3|4|e?g)|mov(ie)?|msi|msp|pdf|phps|png|ppt|qtm?|ra(m|r)?|sea|sit|tar|tgz|torrent|txt|wav|wma|wmv|wpd||xls|xml|z|zip',
        configHostsAlias = [windowAlias.location.hostname],
        configIgnoreClasses = [],
        configDownloadClasses = [],
        configLinkClasses = [],
        configTrackerPause = 500,
        configCustomData,
        pageReferrer, ltid = '0',
        ebid = '0',
        ebslid = '0',
        eblid = '0',
        ltsid = '',
        ltmuid = '',
        affid = '',
        linkTrackingInstalled = false,
        escapeWrapper = windowAlias.encodeURIComponent || escape,
        unescapeWrapper = windowAlias.decodeURIComponent || unescape,
        stringify = function(d) {
          let e = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
            meta = {
              '\b': '\\b',
              '\t': '\\t',
              '\n': '\\n',
              '\f': '\\f',
              '\r': '\\r',
              '"': '\\"',
              '\\': '\\\\'
            };

          function quote(b) {
            e.lastIndex = 0;
            return e.test(b) ? '"' + b.replace(e, function(a) {
              let c = meta[a];
              return typeof c === 'string' ? c : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4)
            }) + '"' : '"' + b + '"'
          }

          function f(n) {
            return n < 10 ? '0' + n : n
          }

          function str(a, b) {
            let i, k, v, partial, d = b[a];
            if (d === null) {
              return 'null'
            }
            if (d && typeof d === 'object' && typeof d.toJSON === 'function') {
              d = d.toJSON(a)
            }
            switch (typeof d) {
              case 'string':
                return quote(d);
              case 'number':
                return isFinite(d) ? String(d) : 'null';
              case 'boolean':
              case 'object':
                partial = [];
                if (d instanceof Array) {
                  for (i = 0; i < d.length; i++) {
                    partial[i] = str(i, d) || 'null'
                  }
                  v = partial.length === 0 ? '[]' : '[' + partial.join(',') + ']';
                  return v
                }
                if (d instanceof Date) {
                  return quote(d.getUTCFullYear() + '-' + f(d.getUTCMonth() + 1) + '-' + f(d.getUTCDate()) + 'T' + f(d.getUTCHours()) + ':' + f(d.getUTCMinutes()) + ':' + f(d.getUTCSeconds()) + 'Z')
                }
                for (k in d) {
                  v = str(k, d);
                  if (v) {
                    partial[partial.length] = quote(k) + ':' + v
                  }
                }
                v = partial.length === 0 ? '{}' : '{' + partial.join(',') + '}';
                return v
            }
          }
          return str('', {
            '': d
          })
        };

      function setCookie(a, b, c, d, e, f) {
        let g;
        if (c) {
          g = new Date();
          g.setTime(g.getTime() + (c * 8.64e7))
        }
        documentAlias.cookie = a + '=' + escapeWrapper(b) + (c ? ';expires=' + g.toUTCString() : '') + ';path=' + (d ? d : '/') + (e ? ';domain=' + e : '') + (f ? ';secure' : '')
      }

      function getCookie(a, b, c) {
        let d = new RegExp('(^|;)[ ]*' + a + '=([^;]*)' + (b ? '(;[ ]*expires=[^;]*)?;[ ]*path=' + b.replace('/', '\\/') + '' : '') + (c ? ';[ ]*domain=' + c + '(;|$)' : '')),
          cookieMatch = d.exec(documentAlias.cookie);
        return cookieMatch ? unescapeWrapper(cookieMatch[2]) : 0
      }

      function getImage(a, b) {
        let c = new Date(),
          image = new Image(1, 1);
        z = c.getTime() + b;
        image.src = a
      }

      function getReferrer() {
        let a = '';
        
        // try {
        //   a = top.document.referrer
        // } catch (e) {
        //   if (parent) {
        //     try {
        //       a = parent.document.referrer
        //     } catch (e2) {
        //       a = ''
        //     }
        //   }
        // }
        // if (a === '') {
        //   a = documentAlias.referrer
        // }

        // Omit referrer, needs to be able to handle overwritten page url
        return a
      }

      function hasCookies() {
        let a = '_gt_testcookie';
        if (!isDefined(navigatorAlias.cookieEnabled)) {
          setCookie(a, '1');
          return getCookie(a) === '1' ? '1' : '0'
        }
        return navigatorAlias.cookieEnabled ? '1' : '0'
      }

      function getRequest() {
        let request = 'tracking_id=' + configTrackerSiteId + '&url=' + escapeWrapper(pageUrlOverride || documentAlias.location.href) + '&urlref=' + escapeWrapper(pageReferrer);
        request = l + '?' + request;
        return request
      }

      function getTrackServlet() {
        if (checkConfigTrackerSiteId(configTrackerSiteId)) {
          let a = getRequest();
          a += '&title=' + escapeWrapper(configTitle);
          if (isDefined(configCustomData)) {
            a += '&data=' + escapeWrapper(stringify(configCustomData))
          }
          a += '&gtlid=' + ltid;
          if (ebid != '0' && ebslid != '0') {
            a += '&ebid=' + ebid + '&ebslid=' + ebslid;
            if (eblid != '0') {
              a += '&eblid=' + eblid
            }
          }
          a += '&ltsid=' + ltsid;
          if (ltmuid != '') {
            a += '&ltmuid=' + ltmuid
          }
          getImage(a, configTrackerPause)
        } else {
          let a = 'http://api.genoo2.com/assets/dot.gif?track=g26a2j212agasda328';
          for (let i = 0; i < 30; i++) {
            getImage(a + i, configTrackerPause)
          }
        }
      }

      function checkConfigTrackerSiteId(a) {
        let invalid = [
          '001etk20440780:omyhydsm',
          '001etk30404400:3HRskjog',
          '001etk17807310:ruqxhj',
          '001etk16692495:faefdahumw',
          '001etk16875870:IviZjolply',
          '001etk17601870:WplywvuaJL',
          '001etk46269005:wkebooxfvygo'
        ];

        return invalid.indexOf(a) === -1;
      }

      function logClick(a, b, c) {
        if (checkConfigTrackerSiteId(configTrackerSiteId)) {
          let d = 'tracking_id=' + configTrackerSiteId + '&' + b + '=' + escapeWrapper(a) + '&redirect=0&host=' + configHostsAlias;
          if (isDefined(c)) {
            if (c !== null) {
              d += '&title=' + escapeWrapper(c)
            }
          }
          d += '&gtlid=' + ltid;
          if (ebid != '0' && ebslid != '0' && eblid != '0') {
            d += '&ebid=' + ebid + '&ebslid=' + ebslid + '&eblid=' + eblid
          }
          d += '&ltsid=' + ltsid;
          if (ltmuid != '') {
            d += '&ltmuid=' + ltmuid
          }
          d += '&urlref=' + escapeWrapper(pageUrlOverride || document.location.href);
          d = l + '?' + d;
          getImage(d, configTrackerPause)
        }
      }

      function isSiteHostName(a) {
        let i, alias, offset;
        for (i = 0; i < configHostsAlias.length; i++) {
          alias = configHostsAlias[i];
          if (a === alias) {
            return true
          }
          if (alias.substr(0, 2) === '*.') {
            if (a === alias.substr(2)) {
              return true
            }
            offset = a.length - alias.length + 1;
            if ((offset > 0) && (a.substr(offset) === alias.substr(1))) {
              return true
            }
          }
        }
        return false
      }

      function getClassesRegExp(a, b) {
        let i, classesRegExp = '(^| )(gtrack_' + b;
        if (isDefined(a)) {
          for (i = 0; i < a.length; i++) {
            classesRegExp += '|' + a[i]
          }
        }
        classesRegExp += ')( |$)';
        return new RegExp(classesRegExp)
      }

      function getLinkType(a, b, c) {
        if (!c) {
          return 'link'
        }
        let d = getClassesRegExp(configDownloadClasses, 'download'),
          linkPattern = getClassesRegExp(configLinkClasses, 'link'),
          downloadExtensionsPattern = new RegExp('\\.(' + configDownloadExtensions + ')$', 'i');
        return linkPattern.test(a) ? 'link' : (d.test(a) || downloadExtensionsPattern.test(b) ? 'download' : 0)
      }

      function clickHandler(a) {
        let b, parentElement, tag, linkType;
        if (!isDefined(a)) {
          a = windowAlias.event
        }
        if (isDefined(a.target)) {
          b = a.target
        } else {
          return
        }
        while ((parentElement = b.parentNode) && ((tag = b.tagName) !== 'A' && tag !== 'AREA')) {
          b = parentElement
        }
        if (isDefined(b.href)) {
          let c = b.hostname,
            sourceHostName = c.toLowerCase(),
            sourceHref = b.href.replace(c, sourceHostName),
            scriptProtocol = /^(javascript|vbscript|jscript|mocha|livescript|ecmascript): */i;
          if (!scriptProtocol.test(sourceHref)) {
            linkType = getLinkType(b.className, sourceHref, isSiteHostName(sourceHostName));
            if (linkType) {
              logClick(sourceHref, linkType)
            }
          }
        }
      }

      function addClickListener(a) {
        addEventListener(a, 'click', clickHandler, false)
      }

      function addClickListeners() {
        if (!linkTrackingInstalled) {
          linkTrackingInstalled = true;
          let i, ignorePattern = getClassesRegExp(configIgnoreClasses, 'ignore'),
            linkElements = documentAlias.links;
          if (linkElements) {
            for (i = 0; i < linkElements.length; i++) {
              if (!ignorePattern.test(linkElements[i].className)) {
                addClickListener(linkElements[i])
              }
            }
          }
        }
      }

      function queryString(a) {
        let q = window.location.search;
        let b = "";
        if (q.length > 1) {
          this.q = q.substring(1, q.length)
        }
        this.keyValuePairs = [];
        if (q) {
          for (let i = 0; i < this.q.split("&").length; i++) {
            this.keyValuePairs[i] = this.q.split("&")[i];
            if (this.keyValuePairs[i].split("=")[0] === a) {
              b = unescape(this.keyValuePairs[i].split("=")[1])
            }
          }
        }
        return b
      }

      function makeSessionID() {
        let a = "";
        let b = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (let i = 0; i < 18; i++) {
          a += b.charAt(Math.floor(Math.random() * b.length))
        }
        return a
      }

      function makeMUID() {
        let a = "";
        let b = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
        for (let i = 0; i < 18; i++) {
          a += b.charAt(Math.floor(Math.random() * b.length))
        }
        return a
      }
      pageReferrer = getReferrer();
      if (hasCookies()) {
        let m = (queryString('upid'));
        let o = (queryString('ebid'));
        let p = (queryString('ebslid'));
        let r = (queryString('eblid'));
        let t = (queryString('ref'));
        if (m != '' && m != '0') {
          setCookie('_gtld', m, 90, '/', configHostsAlias, '');
          ltid = m
        } else {
          ltid = getCookie('_gtld', '', '')
        }
        if (ltid == '' || ltid == 0) {
          ltid = getCookie('_gtld', '', '')
        }
        if (ltid != '' && ltid > 0) {
          setCookie('_gtld', ltid, 90, '/', configHostsAlias, '')
        }
        if (ltid == '' || ltid == 0) {
          ltmuid = getCookie('_gtmuid', '', '');
          if (ltmuid == '') {
            ltmuid = makeMUID();
            setCookie('_gtmuid', ltmuid, 90, '/', configHostsAlias, '')
          } else {
            setCookie('_gtmuid', ltmuid, 90, '/', configHostsAlias, '')
          }
        } else {
          ltmuid = getCookie('_gtmuid', '', '');
          if (ltmuid != '') {
            setCookie('_gtmuid', ltmuid, 90, '/', configHostsAlias, '')
          }
        }
        if (o != '' && o != '0') {
          ebid = o;
          setCookie('_gtebid', ebid, 0.0208, '/', configHostsAlias, '')
        } else {
          ebid = getCookie('_gtebid', '', '');
          if (ebid != '') {
            setCookie('_gtebid', ebid, 0.0208, '/', configHostsAlias, '')
          }
        }
        if (p != '' && p != '0') {
          ebslid = p;
          setCookie('_gtebslid', ebslid, 0.0208, '/', configHostsAlias, '')
        } else {
          ebslid = getCookie('_gtebslid', '', '');
          if (ebslid != '') {
            setCookie('_gtebslid', ebslid, 0.0208, '/', configHostsAlias, '')
          }
        }
        if (r != '' && r != '0') {
          eblid = r
        }
        ltsid = getCookie('_gtlsid', '', '');
        if (ltsid == '' || ltsid == '0') {
          ltsid = makeSessionID();
          setCookie('_gtlsid', ltsid, 0.0208, '/', configHostsAlias, '')
        }
        if (ltsid != '') {
          setCookie('_gtlsid', ltsid, 0.0208, '/', configHostsAlias, '')
        }
        let u = getCookie('_gtref', '', '');
        if ((m == '' || m == '0') && (u == '' || u == '0')) {
          setCookie('_gtref', pageReferrer, '', '/', configHostsAlias, '')
        }
        if (t != '' && t != '0') {
          setCookie('_gtaffid', t, 90, '/', configHostsAlias, '');
          affid = t
        } else {
          affid = getCookie('_gtaffid', '', '')
        }

        function loadTrackFormInputs(a) {
          let b = window.onload;
          window.onload = function() {
            if (typeof window.onload != 'function') {
              b();
            }

            a()
          }
        }
        loadTrackFormInputs(function() {
          let a = document.getElementsByClassName("ext-form");
          for (let i = 0; i < a.length; i++) {
            let b = a[i];
            let c = document.createElement("input");
            c.type = "hidden";
            c.name = "source_referer";
            c.value = u;
            b.appendChild(c);
            if (ltsid != '') {
              c = document.createElement("input");
              c.type = "hidden";
              c.name = "ltsid";
              c.value = ltsid;
              b.appendChild(c)
            }
            if (ltsid != '') {
              c = document.createElement("input");
              c.type = "hidden";
              c.name = "ltmuid";
              c.value = ltmuid;
              b.appendChild(c)
            }
            if (ebid != '' && ebid != '0') {
              c = document.createElement("input");
              c.type = "hidden";
              c.name = "ebid";
              c.value = ebid;
              b.appendChild(c);
              if (ebslid != '' && ebslid != '0') {
                c = document.createElement("input");
                c.type = "hidden";
                c.name = "ebslid";
                c.value = ebslid;
                b.appendChild(c)
              }
            }
            if (affid != '' && affid != '0') {
              c = document.createElement("input");
              c.type = "hidden";
              c.name = "ltaffid";
              c.value = affid;
              b.appendChild(c)
            }
            if (parseInt(ltid) > 0 && b.prefill && b.prefill.value == 'true') {
              let s = l.replace("tracking", "rlis");
              let k = b.form_key.value;
              let d = s + '?_gtld=' + ltid + '&form_key=' + k + '&output=json';
              aObj = new GPrefillscriptRequest(d);
              aObj.buildScriptTag();
              aObj.addScriptTag()
            }
            if (b.eventreg && b.eventreg.value == 'true') {
              var s = l.replace("tracking", "revsc");
              var k = b.form_key.value;
              var d = s + '?form_key=' + k + '&output=json';
              aObj = new GPrefillscriptRequest(d);
              aObj.buildScriptTag();
              aObj.addScriptTag()
            }
          }
        });
      }
      return {
        setTrackingUrl(url) {
          if (typeof url === 'string') {
            pageUrlOverride = url;
          }
        },
        setTrackerUrl: function(a) {
          if (isDefined(a)) {
            l = a
          }
        },
        setSiteId: function(a) {
          if (isDefined(a)) {
            configTrackerSiteId = a
          }
        },
        setLinkTrackingTimer: function(a) {
          if (isDefined(a)) {
            configTrackerPause = a
          }
        },
        setDownloadExtensions: function(a) {
          if (isDefined(a)) {
            configDownloadExtensions = a
          }
        },
        addDownloadExtensions: function(a) {
          if (isDefined(a)) {
            configDownloadExtensions += '|' + a
          }
        },
        setDomains: function(a) {
          if (typeof a == 'object' && a instanceof Array) {
            configHostsAlias = a;
            configHostsAlias[configHostsAlias.length] = windowAlias.location.hostname
          } else if (typeof a == 'string') {
            configHostsAlias = [a, windowAlias.location.hostname]
          }
        },
        setIgnoreClasses: function(a) {
          if (typeof a == 'object' && a instanceof Array) {
            configIgnoreClasses = a
          } else if (typeof a == 'string') {
            configIgnoreClasses = [a]
          }
        },
        setDocumentTitle: function(a) {
          if (isDefined(a)) {
            configTitle = a
          }
        },
        setDownloadClasses: function(a) {
          if (typeof a == 'object' && a instanceof Array) {
            configDownloadClasses = a
          } else if (typeof a == 'string') {
            configDownloadClasses = [a]
          }
        },
        setDownloadClass: function(a) {
          if (typeof a == 'string') {
            configDownloadClasses = [a]
          }
        },
        setLinkClasses: function(a) {
          if (typeof a == 'object' && a instanceof Array) {
            configLinkClasses = a
          } else if (typeof a == 'string') {
            configLinkClasses = [a]
          }
        },
        setLinkClass: function(a) {
          if (typeof a == 'string') {
            configLinkClasses = [a]
          }
        },
        addListener: function(a) {
          if (isDefined(a)) {
            addClickListener(a)
          }
        },
        enableLinkTracking: function() {
          if (hasLoaded) {
            addClickListeners()
          } else {
            registeredOnLoadHandlers[registeredOnLoadHandlers.length] = function() {
              addClickListeners()
            }
          }
        },
        trackLink: function(a, b, c) {
          logClick(a, b, c)
        },
        trackPageView: function() {
          getTrackServlet()
        }
      }
    }

    addReadyListener();
    return {
      getTracker: function(a, b) {
        return new Tracker(a, b)
      }
    }
  }())
}

function GPrefillscriptRequest(a) {
  this.fullUrl = a;
  this.noCacheIE = '&noCacheIE=' + (new Date()).getTime();
  this.headLoc = document.getElementsByTagName('head').item(0);
  this.scriptId = 'JscriptId' + GPrefillscriptRequest.scriptCounter++;
}
GPrefillscriptRequest.scriptCounter = 1;
GPrefillscriptRequest.prototype.buildScriptTag = function() {
  this.scriptObj = document.createElement('script');
  this.scriptObj.setAttribute('type', 'text/javascript');
  this.scriptObj.setAttribute('charset', 'utf-8');
  this.scriptObj.setAttribute('src', this.fullUrl + this.noCacheIE);
  this.scriptObj.setAttribute('id', this.scriptId);
};
GPrefillscriptRequest.prototype.removeScriptTag = function() {
  this.headLoc.removeChild(this.scriptObj);
};
GPrefillscriptRequest.prototype.addScriptTag = function() {
  this.headLoc.appendChild(this.scriptObj);
};

function pfdata(a) {
  let b = a.ldata;
  let c = document.getElementsByClassName("ext-form");
  let x, i;
  let d;
  for (x = 0; x < c.length; x++) {
    d = c[x];
    for (i = 0; i < b.length; i++) {
      if (d.elements[b[i].label]) {
        d.elements[b[i].label].value = b[i].data
      }
    }
  }
}
var evaddedto = [];

function eventdata(jsonData) {
  var arr = jsonData.schedules;
  var selectelm = document.getElementsByName("scheduleid");
  var option;
  for (x = 0; x < selectelm.length; x++) {
    if (evaddedto.indexOf(selectelm[x].id) === -1) {
      for (i = 0; i < arr.length; i++) {
        option = document.createElement("option");
        option.text = arr[i].date;
        option.value = arr[i].schedule;
        selectelm[x].add(option)
      }
      evaddedto.push(selectelm[x].id)
    }
  }
  try {
    aObj.removeScriptTag()
  } catch (err) {}
}